import { defineStore } from "pinia";

export const MessageStore = defineStore('messageStore', {
    state: () => ({message: String, active: Boolean, type: Boolean}),
    getters: {

    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        setMessage(message, type) {
            this.message = message;
            this.type = type;
            this.active = true;
        },
        inactivateMessage(){
            this.active = false;
        }
    },



}) 